import React, { useEffect, useState } from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp';
import GalleryModal from '../../Components/Gallery/GalleryModal';
import { BsArrowUp } from 'react-icons/bs';
import HTMLFlipBook from "react-pageflip";

const array1 = Array.from({ length: 57 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/${i + 1}.jpg`,
})).reverse();

const array2 = Array.from({ length: 131 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/${i + 58}.png`,
})).reverse();

const galleryArray = [...array1, ...array2]

const food = Array.from({ length: 105 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/Food/New/${i + 1}.webp`,
})).reverse();

// const interior = Array.from({ length: 16 }, (_, i) => ({
//     src: `https://albidayahgroups.com/Media/Gallery/Interior/webp/${i + 1}.webp`,
// })).reverse();


const interior = Array.from({ length: 28 }, (_, i) => ({
  src: `https://albidayahgroups.com/Media/Gallery/Interior/webp/${i + 1}.webp`,
}))
  .filter((item, index) => index !== 0 && index !== 2 && index !== 24 && index !== 27) // ignore 1 and 3
//   .reverse();


const staff = Array.from({ length: 12 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/Staff/webp/${i + 1}.webp`,
})).reverse();

const apron = Array.from({ length: 16 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/Apron/${i + 1}.jpg`,
})).filter((item, index) => index !== 0) // ignore 1 and 3
//   .reverse();;

// // Generate apron images
// const apron = Array.from({ length: 15 }, (_, i) => ({
//   src: `https://albidayahgroups.com/Media/Gallery/Apron/${i + 1}.jpg`,
// }));

// // Shuffle function (Fisher–Yates)
// function shuffleArray(array) {
//   let currentIndex = array.length, randomIndex;

//   // While there remain elements to shuffle
//   while (currentIndex !== 0) {
//     // Pick a remaining element
//     randomIndex = Math.floor(Math.random() * currentIndex);
//     currentIndex--;

//     // Swap it with the current element
//     [array[currentIndex], array[randomIndex]] = [
//       array[randomIndex], array[currentIndex]
//     ];
//   }

//   return array;
// }

// // Use shuffled apron array
// const shuffledApron = shuffleArray([...apron]);


const menu1Pages = Array.from({ length: 12 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/Staff/webp/${i + 1}.webp`,
}));

const menu2Pages = Array.from({ length: 11 }, (_, i) => ({
    src: `https://albidayahgroups.com/Media/Gallery/Staff/webp/${i + 1}.webp`,
}));

export default function Categorize() {

    const [modalImageSrc, setModalImageSrc] = useState(null);
    const [playingVideo, setPlayingVideo] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const handlePlay = (videoSrc) => {
        setPlayingVideo(videoSrc);
    };

    // State to manage the active tab
    const [activeTab, setActiveTab] = useState('food');

    // Function to handle tab clicks
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    const openModal = (src) => {
        setModalImageSrc(src);
    };

    const closeModal = () => {
        setModalImageSrc(null);
    };

    return (
        <div className=''>
            <div className="border-gray-200 dark:border-gray-700 flex justify-center items-center py-10">
                <ul className="flex flex-wrap justify-center items-center text-3xl xl:text-3xl sm:text-2xl max-sm:text-lg font-medium text-center gap-28 xl:gap-28 sm:gap-5 max-sm:gap-5" role="tablist">
                    <li className="me-2" role="presentation">
                        <button
                            className={`inline-block border-b-2 rounded-lg ${activeTab === 'food' ? 'border-black bg-black text-white p-2' : 'border-transparent'}`}
                            onClick={() => handleTabClick('food')}
                            type="button"
                            role="tab"
                            aria-controls="food"
                            aria-selected={activeTab === 'food'}
                        >
                            Our Food
                        </button>
                    </li>
                    <li className="me-2" role="presentation">
                        <button
                            className={`inline-block border-b-2 rounded-lg ${activeTab === 'interior' ? 'border-black bg-black text-white p-2' : 'border-transparent'}`}
                            onClick={() => handleTabClick('interior')}
                            type="button"
                            role="tab"
                            aria-controls="interior"
                            aria-selected={activeTab === 'interior'}
                        >
                            The Interior
                        </button>
                    </li>
                    <li className="me-2" role="presentation">
                        <button
                            className={`inline-block border-b-2 rounded-lg ${activeTab === 'staff' ? 'border-black bg-black text-white p-2' : 'border-transparent'}`}
                            onClick={() => handleTabClick('staff')}
                            type="button"
                            role="tab"
                            aria-controls="staff"
                            aria-selected={activeTab === 'staff'}
                        >
                            Our Team
                        </button>
                    </li>
                    <li className="me-2" role="presentation">
                        <button
                            className={`inline-block border-b-2 rounded-lg ${activeTab === 'apron' ? 'border-black bg-black text-white p-2' : 'border-transparent'}`}
                            onClick={() => handleTabClick('apron')}
                            type="button"
                            role="tab"
                            aria-controls="apron"
                            aria-selected={activeTab === 'apron'}
                        >
                            Behind The Apron
                        </button>
                    </li>
                    {/* <li className="me-2" role="presentation">
                        <button
                            className={`inline-block border-b-2 rounded-t-lg ${activeTab === 'menu' ? 'border-black' : 'border-transparent'}`}
                            onClick={() => handleTabClick('menu')}
                            type="button"
                            role="tab"
                            aria-controls="menu"
                            aria-selected={activeTab === 'menu'}
                        >
                            Our Menu
                        </button>
                    </li> */}
                </ul>
            </div>
            <div className='pb-20'>
                {activeTab === 'food' && (
                    <div className="" role="tabpanel" aria-labelledby="food-tab">
                        <div>
                            <div className="px-5 max-sm:px-2">
                                <div className="flex justify-center items-center">
                                    <div className='grid grid-cols-3 max-sm:grid-cols-2 gap-5 max-sm:gap-2'>
                                        {food.map((image, index) => (
                                            <FadeInSectionDownToUp>
                                                <img key={index} className='rounded-3xl max-sm:rounded w-full' src={image.src} alt={image.alt} onClick={() => openModal(image.src)} loading='lazy' />
                                            </FadeInSectionDownToUp>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'interior' && (
                    <div className="" role="tabpanel" aria-labelledby="interior-tab">
                        <div>
                            <div className="px-5 max-sm:px-2">
                                <div className="flex justify-center items-center">
                                    <div className='grid grid-cols-3 max-sm:grid-cols-2 gap-5 max-sm:gap-2'>
                                        {interior.map((image, index) => (
                                            <FadeInSectionDownToUp>
                                                <img key={index} className='rounded-3xl max-sm:rounded w-full' src={image.src} alt={image.alt} onClick={() => openModal(image.src)} loading='lazy' />
                                            </FadeInSectionDownToUp>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'staff' && (
                    <div className="" role="tabpanel" aria-labelledby="staff-tab">
                        <div>
                            <div className="px-5 max-sm:px-2">
                                <div className="flex justify-center items-center">
                                    <div className='grid grid-cols-3 max-sm:grid-cols-2 gap-5 max-sm:gap-2'>
                                        {staff.map((image, index) => (
                                            <FadeInSectionDownToUp>
                                                <img key={index} className='rounded-3xl max-sm:rounded w-full' src={image.src} alt={image.alt} onClick={() => openModal(image.src)} loading='lazy' />
                                            </FadeInSectionDownToUp>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'apron' && (
                    <div className="" role="tabpanel" aria-labelledby="apron-tab">
                        <div>
                            <div className="px-5 max-sm:px-2">
                                <div className="flex justify-center items-center">
                                    <div className='grid grid-cols-3 max-sm:grid-cols-2 gap-5 max-sm:gap-2'>
                                        {apron.map((image, index) => (
                                            <FadeInSectionDownToUp>
                                                <img key={index} className='rounded-3xl max-sm:rounded w-full' src={image.src} alt={image.alt} onClick={() => openModal(image.src)} loading='lazy' />
                                            </FadeInSectionDownToUp>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeTab === 'menu' && (
                    <div role="tabpanel" aria-labelledby="menu-tab" className="px-4">
                        <div className="flex flex-col items-center gap-12">
                            <div>
                                <h2 className="text-2xl font-semibold text-center mb-4">Menu 1</h2>
                                <HTMLFlipBook
                                    width={300}
                                    height={400}
                                    size="stretch"
                                    minWidth={315}
                                    maxWidth={500}
                                    minHeight={400}
                                    maxHeight={800}
                                    maxShadowOpacity={0.5}
                                    showCover={true}
                                    mobileScrollSupport={true}
                                    className="menu-book"
                                >
                                    {menu1Pages.map((page, index) => (
                                        <div key={index} className="bg-white w-full h-full">
                                            <img
                                                src={page.src}
                                                alt={`Menu 1 Page ${index + 1}`}
                                                className="w-full h-full object-contain"
                                                loading="lazy"
                                            />
                                        </div>
                                    ))}
                                </HTMLFlipBook>
                            </div>
                            <div>
                                <h2 className="text-2xl font-semibold text-center mb-4">Menu 2</h2>
                                <HTMLFlipBook
                                    width={300}
                                    height={400}
                                    size="stretch"
                                    minWidth={315}
                                    maxWidth={500}
                                    minHeight={400}
                                    maxHeight={800}
                                    maxShadowOpacity={0.5}
                                    showCover={true}
                                    mobileScrollSupport={true}
                                    className="menu-book"
                                >
                                    {menu2Pages.map((page, index) => (
                                        <div key={index} className="bg-white w-full h-full">
                                            <img
                                                src={page.src}
                                                alt={`Menu 2 Page ${index + 1}`}
                                                className="w-full h-full object-contain"
                                                loading="lazy"
                                            />
                                        </div>
                                    ))}
                                </HTMLFlipBook>
                            </div>
                        </div>
                    </div>
                )} */}
            </div>
            <GalleryModal
                isOpen={!!modalImageSrc}
                imageSrc={modalImageSrc}
                onClose={closeModal}
            />
            <div className="flex justify-end items-end max-sm:pb-10 sticky bottom-14 max-sm:bottom-0 pr-4">
                {isVisible && (
                    <div className="fixed bottom-14 right-5 max-sm:bottom-4 z-50">
                        <button
                            onClick={scrollToTop}
                            className="bg-white dark:bg-slate-500 dark:bg-opacity-40 p-1 rounded-xl"
                        >
                            <BsArrowUp size={30} />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
